/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = "scrollview.previous", s = "scrollview.next", o = {
  [e]: "Previous",
  [s]: "Next"
};
export {
  o as messages,
  s as next,
  e as previous
};
